export default {
  state: {
    status: '',
    milestoneSubcategories: [],
  },
  mutations: {
    milestoneSubcategory_request(state) {
      state.status = 'loading';
    },
    milestoneSubcategory_success(state, milestoneSubcategories) {
      state.status = 'success';
      state.milestoneSubcategories = milestoneSubcategories;
    },
    milestoneSubcategory_error(state) {
      state.status = 'error';
    },
  },
  actions: {
    setMilestoneSubcategories({commit}, milestoneSubcategories) {
      commit('milestoneSubcategory_success', milestoneSubcategories);
    },
  },
  getters: {
    milestoneSubcategories: (state) => {
      return state.milestoneSubcategories;
    },
  },
};
